define([
	'internal_util/Util',
	'model/Error',
	'model/ErrorType',
	'amdi18n-loader?!internal_util/nls/Configuration_strings',
	'../environment/environment-BUILD_TARGET',
	'lib/jquery'
], function (
	Util,
	Error,
	ErrorType,
	Strings,
	_configuration,
	jQuery
) {
	'use strict';

	let EventEmitter = function() {
		this.callbacks = {}
	}
	EventEmitter.prototype.on = function(event, cb){
		if(!this.callbacks[event]) this.callbacks[event] = [];
		this.callbacks[event].push(cb)
	}
	EventEmitter.prototype.emit = function(event, data){
		let cbs = this.callbacks[event]
		if(cbs){
			for (let cb of cbs) {
				try {
					cb(data);
				} catch(e) {
					console.log("Callback Function not working.", e);
					if (e.stack) {
						console.log(e.stack);
					}
				}
			}
		}
	}

	let events = new EventEmitter();

	function on(event, cb) {
		events.on(event, cb);
	}

	function get(identifier) {
		let retVal;

		if (_configuration.hasOwnProperty(identifier)) {
			retVal = _configuration[identifier];

			switch (retVal) {
			case 'true':
			case 'TRUE':
				return true;
			case 'false':
			case 'FALSE':
				return false;
			default:
				return retVal;
			}
		}

		return null;
	}

	function getAll() {
		return _configuration;
	}

	function checkConfig() {
		if (!Util.isValidString(get('VERSION'))) {
			throw new Error(Strings.version_invalid + ': ' + get('VERSION'));
		}

		if (!Util.isValidURL(get('OPTIONS_URL'))) {
			throw new Error(Strings.options_url_invalid + ': ' + get('OPTIONS_URL'));
		}

		if (!Util.isValidURL(get('IDM_URL'))) {
			throw new Error(Strings.IDM_URL_invalid + ': ' + get('IDM_URL'));
		}

		if (!Util.isValidURL(get('FF_IDM_START_URL'))) {
			throw new Error(Strings.IDM_URL_invalid + ': ' + get('FF_IDM_START_URL'));
		}

		if (!Util.isValidURL(get('FF_IDM_FINISH_URL'))) {
			throw new Error(Strings.IDM_URL_invalid + ': ' + get('FF_IDM_FINISH_URL'));
		}

		if (!Util.isValidURL(get('SELECT_OPTION_URL'))) {
			throw new Error(Strings.select_option_url_invalid + ': ' + get('SELECT_OPTION_URL'));
		}

		if (!Util.isValidURL(get('CANCEL_SELECT_OPTION_URL'))) {
			throw new Error(Strings.cancel_select_option_url_invalid + ': ' + get('CANCEL_SELECT_OPTION_URL'));
		}

		if (!Util.isValidURL(get('ATTRIBUTE_DEFINITIONS_URL'))) {
			throw new Error(Strings.attribute_definitions_url_invalid + ': ' + get('ATTRIBUTE_DEFINITIONS_URL'));
		}

		if (!Util.isValidURL(get('PRIVACY_DOCUMENT_URL'))) {
			throw new Error(Strings.privacy_document_url_invalid + ': ' + get('PRIVACY_DOCUMENT_URL'));
		}

		if (!Util.isValidURL(get('CLOUD_IDENTITY_REQUEST_URL'))) {
			throw new Error(Strings.cloud_identity_request_url_invalid + ': ' + get('CLOUD_IDENTITY_REQUEST_URL'));
		}

		if (!Util.isValidURL(get('CLOUD_IDENTITY_MANAGEMENT_URL'))) {
			throw new Error(Strings.cloud_identity_management_url_invalid + ': ' + get('CLOUD_IDENTITY_MANAGEMENT_URL'));
		}

		if (!Util.isValidURL(get('OPEN_ECARD_SUPPORTED_CARDS_PROTOCOLS_URL'))) {
			throw new Error(Strings.open_ecard_supported_cards_protocols_url_invalid + ': ' + get('OPEN_ECARD_SUPPORTED_CARDS_PROTOCOLS_URL'));
		}

		if (!Util.isValidURL(get('OPEN_ECARD_APP_STATUS_URL'))) {
			throw new Error(Strings.open_ecard_app_status_url_invalid + ': ' + get('OPEN_ECARD_APP_STATUS_URL'));
		}

		if (!Util.isValidURL(get('JAVA_DOWNLOAD_URL'))) {
			throw new Error(Strings.java_download_url_invalid + ': ' + get('JAVA_DOWNLOAD_URL'));
		}
	}

	function checkConfigAsync(callbacks, errorCallbacks) {
		setTimeout(function() {
			try {
				checkConfig();
			} catch (error) {
				error = new Error(ErrorType.NON_RECOVERABLE, Strings.fetch_configuration_failed, error);
				Util.callCallbacks(errorCallbacks, error);
				return
			}

			if (get('DEBUG') && typeof console !== 'undefined') {
				console.log('Configuration.fetchConfiguration(): Configuration options fetched');
			}

			// Get param 'tenant' from URL and append it to the _configurationURL.
			// Case 1: First request (e.g. /ff-ekiosk/#ctx=idm&tenant=id-123-456)
			// Case 2: After returning from SkIDentity (e.g. /ff-ekiosk/#response=base64-encoded-string&relay-state=base64-encoded-string)
			//   with param response == {"Session":"aSteMmKweLVKzpEjf1SF6g"}
			//   with param relay-state == {"ctx":"idm","tenant":"296e3cc7-b7d2-4e1c-b907-a775dbeb6005","cip-cmd":"issue"}
			let tenant = "";
			let params = Util.parseParameters(window.location.hash, false);

			if (params.ctx == "idm" && params.tenant != "") {
				tenant = params.tenant;
			} else if (params["relay-state"] != "") {
				let rsString = params["relay-state"];
				let relayState = JSON.parse(Util.base64Decode(rsString));
				tenant = relayState.tenant;
			}

			// get tenant data
			let tenantDataUrl = get('TENANT_API_URL') + tenant;

			jQuery.ajax({
				url : tenantDataUrl,
				dataType : 'json',
				success : function (tenantData) {
					_configuration['TENANT_ICON_URL'] = tenantData['iconUrl'];
					_configuration['TENANT_PRIVACY_URL'] = tenantData['privacyUrl'];
					_configuration['TENANT_ID'] = tenant;
					events.emit('tenantLoaded');
				},
				error : function (jqXHR) {
					let error = new Error(ErrorType.NON_RECOVERABLE, Strings.fetch_configuration_failed, Util.toString(jqXHR));
					Util.callCallbacks(errorCallbacks, error);
				}
			});

			Util.callCallbacks(callbacks, _configuration);
		}, 100);
	}

	return {
		checkConfigAsync : checkConfigAsync,
		get : get,
		getAll : getAll,
		on: on
	};
});



//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/util/Configuration.js
// module id = 8
// module chunks = 6